import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wave-right"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17.6697 15.9222C18.2108 15.3811 18.2108 14.5037 17.6697 13.9626C17.1286 13.4214 16.2512 13.4214 15.7101 13.9626L17.7948 11.8778C18.3368 11.3359 18.3368 10.4573 17.7948 9.91534C17.2529 9.37342 16.3743 9.37342 15.8324 9.91534L17.1992 8.54852C17.7411 8.0066 17.7411 7.12798 17.1992 6.58607C16.6573 6.04415 15.7787 6.04415 15.2367 6.58607L13.8699 7.95288C14.4118 7.41096 14.4118 6.53234 13.8699 5.99042C13.328 5.4485 12.4494 5.44851 11.9075 5.99042L6.4373 11.4606C6.4364 11.4615 6.43641 11.4591 6.43674 11.4579L7.10544 8.96228C7.22926 8.50016 7.05285 8.00975 6.66302 7.7324C6.11446 7.34213 5.34924 7.50679 5.00975 8.08814L2.78347 11.9005C1.36505 14.3295 1.76279 17.4094 3.75172 19.3984L4.59603 20.2427C7.01317 22.6598 10.9321 22.6598 13.3493 20.2427L17.6697 15.9222Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.7101 13.9626L13.2653 16.4073M15.7101 13.9626L17.7948 11.8778C18.3368 11.3359 18.3368 10.4573 17.7948 9.91534C17.2529 9.37342 16.3743 9.37342 15.8324 9.91534M15.7101 13.9626C16.2512 13.4214 17.1286 13.4214 17.6697 13.9626C18.2108 14.5037 18.2108 15.3811 17.6697 15.9222L13.3493 20.2427C10.9321 22.6598 7.01317 22.6598 4.59603 20.2427L3.75172 19.3984C1.76279 17.4094 1.36505 14.3295 2.78347 11.9005L5.00975 8.08814C5.34924 7.50679 6.11446 7.34213 6.66302 7.7324C7.05285 8.00975 7.22926 8.50016 7.10544 8.96228L6.43795 11.4534C6.43728 11.4559 6.43902 11.4589 6.44084 11.4571L11.9075 5.99042C12.4494 5.44851 13.328 5.4485 13.8699 5.99042C14.4118 6.53234 14.4118 7.41096 13.8699 7.95288M15.8324 9.91534L11.3029 14.4449M15.8324 9.91534L17.1992 8.54852C17.7411 8.0066 17.7411 7.12798 17.1992 6.58607C16.6573 6.04415 15.7787 6.04415 15.2367 6.58607L13.8699 7.95288M13.8699 7.95288L9.34041 12.4824","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.1339 5.58521C20.3714 4.479 19.4117 3.51927 18.3054 2.75684","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WaveRight = Vue.extend<IconProps>({
  name: 'WaveRightIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wave-right',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WaveRight;
